import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=b5d44020&scoped=true&"
import script from "./HelpList.vue?vue&type=script&lang=ts&"
export * from "./HelpList.vue?vue&type=script&lang=ts&"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=b5d44020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d44020",
  null
  
)

export default component.exports